import { render, staticRenderFns } from "./ListRegisterCongress.vue?vue&type=template&id=2ff8f8c4&scoped=true&"
import script from "./ListRegisterCongress.vue?vue&type=script&lang=js&"
export * from "./ListRegisterCongress.vue?vue&type=script&lang=js&"
import style0 from "./ListRegisterCongress.vue?vue&type=style&index=0&id=2ff8f8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8f8c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VContainer,VDataTable})
